import classNames from 'classnames';
import React from 'react';

import Label from './Label';
import { ErrorLabelProps } from './types';

const ErrorLabel = ({ id, text, className, icon, severe = false, ...rest }: ErrorLabelProps): React.JSX.Element => {
    return (
        <Label
            id={id}
            text={text}
            type="error"
            icon={icon}
            className={classNames(className, { 'sgw-label--error-severe': severe })}
            role="alert"
            {...rest}
        />
    );
};

export default ErrorLabel;
